<template>
  <v-row dense class="photo-pick">
    <v-col cols="6">
      <v-btn
        block size="small" variant="outlined" color="primary"
        class="photo-pick-camera-btn"
        :disabled="disabled"
        :loading="loading"
        @click="open('camera')"
      >
        <v-icon start size="small">mdi-camera</v-icon>Tee pilt
      </v-btn>
      <!-- No `multiple` on the camera: a camera hands back one shot, and
           multiple + capture confuses some Android camera intents. -->
      <input
        ref="camera"
        type="file"
        class="photo-pick-input photo-pick-camera"
        tabindex="-1"
        aria-hidden="true"
        capture="environment"
        :accept="accept"
        :disabled="disabled"
        @change="pick"
      />
    </v-col>
    <v-col cols="6">
      <v-btn
        block size="small" variant="outlined" color="primary"
        class="photo-pick-gallery-btn"
        :disabled="disabled"
        :loading="loading"
        @click="open('gallery')"
      >
        <v-icon start size="small">mdi-image-multiple</v-icon>Vali failidest
      </v-btn>
      <input
        ref="gallery"
        type="file"
        class="photo-pick-input photo-pick-gallery"
        tabindex="-1"
        aria-hidden="true"
        multiple
        :accept="accept"
        :disabled="disabled"
        @change="pick"
      />
    </v-col>
  </v-row>
</template>

<script>
// Two buttons, two file inputs: "Tee pilt" opens the camera, "Vali failidest"
// opens the gallery/file manager.
//
// A single picker left the choice to the phone's own chooser, and phones
// disagree about it: some offered Camera alongside the file manager, others
// went straight to the file manager and gave the technician no way to take a
// picture at all. Android's document picker also drops the camera for some
// `accept` values. Two inputs take the decision away from the OS — the camera
// one carries `capture`, the other does not, and nothing else differs.
//
// Same file in akt3/src/components; akt/ and client/ carry the Vue 3 spelling of
// the same thing. The apps build separately and share no module path, exactly
// as photoScale.js is duplicated.

export default {
  emits: ['files'],
  props: {
    disabled: Boolean,
    loading: Boolean,
    // image/* rather than a format list: `accept` is a filter hint and never a
    // conversion, so naming jpeg+png did not stop an iPhone handing over a
    // HEIC — it only greyed out the gallery photos an Android user could see.
    // photoScale.js re-encodes to JPEG on the way out.
    accept: { type: String, default: 'image/*' }
  },
  methods: {
    // Clearing before the click is what lets the same file be picked twice in a
    // row: an unchanged value fires no `change`. The v-file-input this replaced
    // needed a $nextTick reset in every caller for the same reason.
    open (which) {
      const el = this.$refs[which]
      if (!el) return
      el.value = ''
      el.click()
    },
    pick (e) {
      const files = Array.from(e.target.files || [])
      // Safe to clear straight away: the File objects are already in hand.
      e.target.value = ''
      if (files.length) this.$emit('files', files)
    }
  }
}
</script>

<style scoped>
/* Off-screen rather than display:none — older iOS Safari refuses to open a
   display:none file input from script. */
.photo-pick-input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
  clip: rect(0 0 0 0);
  pointer-events: none;
}
</style>
